import React, { JSX } from 'react';

import { Search } from '@videoblocks/design-system/icons';

import ConversationalSearchButton from './ConversationalSearchButton';

/**
 * Trailing controls for the `button` arm of the conversational-search discoverability experiment:
 * a plain magnifying-glass submit (standard search) next to the dedicated Conversational Search CTA.
 * Shared by ProminentSearch and ProminentSearchLegacy so the layout stays identical between them.
 */
export default function ConversationalSearchSubmit({
    disabledForContentType,
    onConversationalSearch,
}: {
    disabledForContentType: boolean;
    onConversationalSearch: () => void;
}): JSX.Element {
    return (
        <>
            <button
                type="submit"
                aria-label="Submit Search"
                className="hidden md:flex shrink-0 grow-0 items-center justify-center border-none bg-transparent px-2 cursor-pointer"
            >
                <Search width={16} height={16} className="[&_path]:fill-gray-700" />
            </button>
            <ConversationalSearchButton
                disabledForContentType={disabledForContentType}
                onClick={onConversationalSearch}
            />
        </>
    );
}
